import React from "react";
import { CalendarCheckIcon, ClipboardListIcon, NotebookPenIcon, OrbitIcon, PlayCircleIcon, BoxIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { CtaButton } from "../CtaButton";
import { extras } from "../../data/content";
const icons: Record<(typeof extras)[number]['icon'], BoxIcon> = {
  practices: PlayCircleIcon,
  checklist: ClipboardListIcon,
  map: OrbitIcon,
  journal: NotebookPenIcon,
  calendar: CalendarCheckIcon
};
export function Extras() {
  return <section className="bg-sand px-5 py-16 sm:py-24" data-id="element-150" data-mp="37ia2ldv7ue33">
      <div className="mx-auto max-w-3xl" data-id="element-151" data-mp="37jl57acxdfsm">
        <SectionHeading eyebrow="Also included" title={<>
              You’ll also <em className="text-brand-700" data-id="element-153" data-mp="3gi5gvrk2ip7c">receive</em>
            </>} data-id="element-152" data-mp="3lhi4wfmoe2bi" />
        <ul className="mt-10 divide-y divide-brand-100 rounded-3xl bg-white px-5 sm:px-8" data-id="element-154" data-mp="3giykijnqcyl9">
          {extras.map(e => {
          const Icon = icons[e.icon];
          return <li key={e.title} className="flex items-start gap-4 py-5" data-id="element-155" data-mp="1m57a3hxkuaor">
                <span className="grid h-12 w-12 shrink-0 place-items-center rounded-xl bg-brand-700 text-white" data-id="element-156" data-mp="w00vf2k1l9yy">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-157" data-mp="10xso3ysih047" />
                </span>
                <div data-id="element-158" data-mp="15x590dztnx45">
                  <h3 className="text-lg font-extrabold text-ink" data-id="element-159" data-mp="15wnd5ih2nkwr">{e.title}</h3>
                  <p className="mt-1 text-[16px] leading-relaxed text-ink-soft" data-id="element-160" data-mp="1aowxmizf3srn">{e.text}</p>
                </div>
              </li>;
        })}
        </ul>
        <CtaButton label="I want the complete system" className="mt-12" data-id="element-161" data-mp="1es349rqfzlyn" />
      </div>
    </section>;
}